// Foundations
import { Injectable } from '@angular/core';

// Models
import { FranchiseLocation } from '../models/franchise.model';

@Injectable({
  providedIn: 'root',
})
export class CamperCamsService {
  selectedLocation: FranchiseLocation;
  newOptionFromSearch: FranchiseLocation;

  constructor() {}
}
